import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Checkbox } from 'semantic-ui-react';

import ProLabel from 'components/common/ProLabel';

import './CommonLinkCheckbox.css';

function CommonLinkCheckbox(props) {
  const {
    linkId,
    initialValue,
    parameter,
    patchFunction,
    label,
    proLabel,
    disabled,
  } = props;

  const [currentValue, setCurrentValue] = useState(null);

  useEffect(() => {
    if (!currentValue) {
      setCurrentValue(initialValue);
    }
  }, []);

  const onCheckboxChange = (_e, { checked }) => {
    const form = new FormData();
    form.append(parameter, checked);
    patchFunction(linkId, form);
    setCurrentValue(!currentValue);
  };

  return (
    <div className="common-link-checkbox__component">
      {(label || proLabel) &&
        <div className="labels-content">
          {label && <div className="label">{label}</div>}
          {proLabel && <ProLabel />}
        </div>
      }
      <Checkbox
        toggle
        checked={currentValue}
        onChange={onCheckboxChange}
        disabled={disabled}
      />
    </div>
  );
}

CommonLinkCheckbox.propTypes = {
  patchFunction: PropTypes.func.isRequired,
  linkId: PropTypes.number.isRequired,
  initialValue: PropTypes.bool.isRequired,
  parameter: PropTypes.string.isRequired,
  label: PropTypes.string,
  proLabel: PropTypes.bool,
  disabled: PropTypes.bool,
};

CommonLinkCheckbox.defaultProps = {
  label: null,
  proLabel: null,
  disabled: null,
};

export default CommonLinkCheckbox;
